import classNames from 'classnames';
import { formatCurrency } from 'helpers/formatNumber';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import {
  TitledBlock,
  FlexContainer,
  ContentBlock,
  Txt,
  PropertyBaseDetails,
} from 'components';
import { usePublicAccount } from 'state';
import styles from './PropertyDetails.module.scss';

/**
 * PropertyDetails
 *
 * @return {JSX.Element}
 */
const PropertyDetails = ({ className, property }) => {
  const publicAccount = usePublicAccount();
  const isSaved = publicAccount.data?.savedPropertyUids.includes(
    property.propertyUid
  );

  console.log(property.data);

  return (
    <FlexContainer
      className={classNames(
        styles.PropertyDetails,
        isSaved && styles.PropertyDetails__isSaved,
        className,
        PropertyDetails.displayName
      )}
      column
      gap
    >
      <a href={`mailto:${property.data.landlordEmail}`} className={styles.Link}>
        <ContentBlock gap>
          <FlexContainer column gapHalf>
            <Txt caption>SIGN ON</Txt>
            <Txt x>Email the Landlord</Txt>
          </FlexContainer>
          <FlexContainer></FlexContainer>
        </ContentBlock>
      </a>
      <FlexContainer column>
        {property.data.search.onTheMarket ? (
          <TitledBlock title="Available From">
            <ContentBlock>
              <Txt>
                {DateTime.fromJSDate(
                  fromSwiftDate(property.data.search.dateAvailable)
                ).toLocaleString(DateTime.DATE_FULL)}
              </Txt>
            </ContentBlock>
          </TitledBlock>
        ) : null}
        <TitledBlock title="Deposit">
          <ContentBlock>
            <Txt>£{formatCurrency(property.data.tenancyDepositAmount)}</Txt>
          </ContentBlock>
        </TitledBlock>
        <PropertyBaseDetails property={property.data} />
      </FlexContainer>
    </FlexContainer>
  );
};

PropertyDetails.displayName = 'PropertyDetails';

export default PropertyDetails;
